import { useState } from "react";
import { ChevronDown } from "lucide-react";

export default function FaqList({ items, dark = false }) {
  const [open, setOpen] = useState(0);
  return (
    <div className={`divide-y ${dark ? "divide-background/15" : "divide-border"}`} data-testid="faq-list">
      {items.map(([q, a], i) => (
        <div key={q} data-testid={`faq-row-${i}`}>
          <button onClick={() => setOpen(open === i ? -1 : i)} aria-expanded={open === i}
                  className="w-full py-5 flex items-center justify-between gap-6 text-left group" data-testid={`faq-toggle-${i}`}>
            <span className="font-head uppercase text-base md:text-lg leading-snug group-hover:text-primary transition-colors">{q}</span>
            <ChevronDown size={18} className={`shrink-0 transition-transform ${open === i ? "rotate-180 text-primary" : ""}`} />
          </button>
          <div className={`grid transition-[grid-template-rows] duration-300 ${open === i ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}>
            <div className="overflow-hidden">
              <p className={`pb-6 text-sm leading-relaxed max-w-3xl ${dark ? "text-background/70" : "text-foreground/70"}`} data-testid={`faq-answer-${i}`}>{a}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
